module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/blue-back-arrow.svg";